(function ($, D)
{
  D.behaviors.scrollTo = {
    attach: function (context, settings) {
      $('[data-scrollto]', context).on('click', function (e) {
        var $elem = $(this);
        var $scroll_to = $elem.data('scrollto') && $($elem.data('scrollto')) || null;
        var scroll_to_top = $scroll_to && $scroll_to.length && $scroll_to.offset().top;

        if (null !== scroll_to_top) {
          e.preventDefault();
          $('html, body').animate({
            scrollTop: scroll_to_top,
          }, 600);
        }
      });
    }
  };
})(jQuery, Drupal);
